// extracted by mini-css-extract-plugin
export var categories = "blog-post-module--categories--AH481";
export var categoriesHeadline = "blog-post-module--categoriesHeadline--aWVrh typography-module--base--FphVn";
export var grid = "blog-post-module--grid--QOScI";
export var mainContent = "blog-post-module--mainContent--eLO5g";
export var mainImage = "blog-post-module--mainImage--IMMYf";
export var metaContent = "blog-post-module--metaContent--nKBLn";
export var publishedAt = "blog-post-module--publishedAt---ggFA typography-module--small--KHf9L";
export var title = "blog-post-module--title--9dCoJ typography-module--responsiveTitle1--0t0jA";